import React, { useState, useRef, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';

interface Props {
    isOpen: boolean;
    children: React.ReactNode;
}

const ExpandingDrawer = ({ isOpen, children }: Props) => {
    const contentContainerRef = useRef<HTMLDivElement | null>(null);
    const [contentHeight, setContentHeight] = useState(0);
    const [shouldMount, setShouldMount] = useState(true);

    useEffect(() => {
        if (!isOpen) {
            setShouldMount(false);
        }
        if (!contentContainerRef?.current) return;
        setContentHeight(contentContainerRef.current.clientHeight);
    }, []);

    const props = useSpring({
        overflow: 'hidden',
        opacity: isOpen ? 1 : 0,
        height: isOpen ? contentHeight : 0,
        onStart: () => isOpen && setShouldMount(true),
        onRest: () => setShouldMount(isOpen)
    });

    return (
        <animated.div style={props}>
            {shouldMount && <div ref={contentContainerRef}>{children}</div>}
        </animated.div>
    );
};

export default ExpandingDrawer;
